import registerConstants from '../../register/constants/register-constants';

const menu_item_callbacks = {
  logout: 'logout',
  legal_documentation: 'legal_documentation',
};

const menu_items = [
  {
    text: 'MENU.DASHBOARD',
    value: 'dashboard',
    path: '/app/dashboard',
    icon: 'glyphicon-dashboard',
  },
  // {
  //   text: 'REPORTS.TITLE',
  //   value: 'reports',
  //   path: '/app/reports',
  //   icon: 'glyphicon glyphicon-list',
  // },
  {
    text: 'MENU.B2B',
    value: 'b2b',
    path: '/app/b2b',
    icon: 'glyphicon-briefcase',
    user_types: [registerConstants.user_types.b2b],
    only_dev: true,
  },
  {
    text: 'CAMPAIGNS.TITLE',
    value: 'campaigns',
    path: '/app/campaigns',
    icon: 'glyphicon-tasks',
    // tabs: [
    //   {
    //     text: 'CAMPAIGNS.TITLE',
    //     path: '/app/campaigns',
    //   },
    //   {
    //     text: 'SOURCES.TITLE',
    //     path: '/app/sources',
    //   },
    // ],
  },
  {
    text: 'MENU.CLIENTS',
    value: 'clients',
    path: '/app/clients',
    icon: 'glyphicon-list-alt',
  },
  {
    text: 'MENU.COMMISSION',
    value: 'commission-scheme',
    path: '/app/commission-scheme',
    icon: 'glyphicon glyphicon-signal',
  },
  {
    text: 'MENU.PROFILE',
    value: 'profile',
    path: '/app/profile',
    icon: 'glyphicon-user',
    tabs: [
      {
        text: 'USER_PROFILE.TITLE',
        path: '/app/profile',
      },
      {
        text: 'CHANGE_PASSWORD.SUBMIT_BTN',
        path: '/app/profile/change-password',
      },
    ],
  },
  {
    text: 'MENU.PAYMENTS',
    value: 'payments',
    path: '/app/withdrawals',
    icon: 'glyphicon-usd',
    tabs: [
      {
        text: 'WITHDRAWALS.TITLE',
        path: '/app/withdrawals',
      },
      {
        text: 'PAYMENT_METHODS.TITLE',
        path: '/app/payment-methods',
      },
      {
        text: 'PAYMENTS.HISTORY',
        path: '/app/payment-history',
      },
    ],
  },
  {
    text: 'MENU.MARKETING_MATERIAL',
    value: 'marketing-material',
    path: '/app/link-creator',
    icon: 'glyphicon-folder-open',
    tabs: [
      {
        text: 'LINK_CREATOR.TITLE',
        path: '/app/link-creator',
      },
      {
        text: 'BANNERS.TITLE',
        path: '/app/banners',
      },
      {
        text: 'LOGOS.TITLE',
        path: '/app/logos',
      },
      {
        text: 'VIDEOS.TITLE',
        path: '/app/videos',
      },
      {
        text: 'MENU.WIDGETS',
        path: '/app/widgets',
      },
    ],
  },
  // {
  //   text: 'COMMISSION_PLANS.TITLE',
  //   value: 'commission-plans',
  //   path: '/app/commission-plans',
  //   icon: 'glyphicon glyphicon-flag',
  // },
  {
    text: 'MENU.LEGAL_DOCUMENTATION',
    icon: 'glyphicon glyphicon-file',
    callback: menu_item_callbacks.legal_documentation,
  },
  {
    text: 'MENU.FAQ',
    value: 'faq',
    path: '/app/faq',
    icon: 'glyphicon glyphicon-question-sign',
  },
  {
    text: 'MENU.LOGOUT',
    icon: 'glyphicon-off',
    callback: menu_item_callbacks.logout,
    isUnblocked: true,
  },
];

const language_form = 'languageForm';

export default {
  menu_items,
  menu_item_callbacks,
  language_form,
};



// WEBPACK FOOTER //
// ./src/app/main/layout/constants/layout-constants.js